
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikcabs() {



  const cardData =
  {
    keyword: 'Pune to Nashik Cabs',
    heading: 'AB Ghule Cabs: Pune to Nashik Cabs',
    headingDescription: 'AB Ghule Cabs offers the most reliable and affordable Pune to Nashik cab service, ensuring a smooth and comfortable journey. Whether you are visiting Nashik for religious purposes, a scenic getaway, or a business trip, our fleet of well-maintained vehicles and experienced drivers will provide you with a safe and pleasant ride. We offer flexible booking options and competitive pricing to cater to your needs.',

    top: 'Top Places to Visit in Nashik with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Trimbakeshwar Temple",
          description: "Trimbakeshwar Temple, one of the twelve Jyotirlingas dedicated to Lord Shiva, is located near the source of the Godavari River in Trimbak, a small town near Nashik. The temple's serene and spiritual atmosphere attracts pilgrims from across the country. It holds significant religious and historical importance, as it is believed to be the origin of the Godavari River. The temple is also an architectural marvel, featuring intricate carvings and sacred rituals. For devotees and history lovers alike, Trimbakeshwar Temple offers a divine experience and a glimpse into India's ancient spiritual traditions."
        },
        {
          title: "Saptashrungi",
          description: "Perched atop a hill, Saptashrungi is a revered temple dedicated to Goddess Saptashrungi. The temple is located in the midst of a mountain range, providing breathtaking views of the surrounding landscape. Known for its scenic beauty and religious significance, Saptashrungi is a popular pilgrimage destination in the Nashik region. Visitors are required to climb a series of steps leading to the temple, adding a sense of adventure to the spiritual journey. The temple’s serene atmosphere and stunning surroundings make it a perfect destination for both spiritual seekers and nature enthusiasts."
        },
        {
          title: "Pandav Leni Caves",
          description: "The Pandav Leni Caves are ancient Buddhist rock-cut caves dating back to the 1st century BCE. Carved into the hillsides, these caves offer a fascinating glimpse into the architectural and cultural history of the region. The caves house intricate sculptures, inscriptions, and beautifully crafted pillars that reflect the Buddhist influence in India. Visitors can explore the serene surroundings and experience the historical significance of these caves, which were once used as meditation and living spaces by Buddhist monks. The Pandav Leni Caves are a must-visit for history buffs and culture enthusiasts."
        },
        {
          title: "Kalaram Sansthan Mandir",
          description: "Kalaram Sansthan Mandir is a revered Hindu temple dedicated to Lord Rama, located in the heart of Nashik. The temple holds a special place in Hindu mythology and is a significant spiritual site. It is known for its peaceful ambiance and the idol of Lord Rama, which is believed to be one of the oldest idols in India. The temple’s architecture is simple yet beautiful, and it attracts thousands of devotees every year, especially during festivals like Ram Navami. For those interested in Hindu spirituality and mythology, Kalaram Sansthan Mandir offers a sacred experience."
        },
        {
          title: "Vineyards of Nashik",
          description: "Nashik is renowned for its vineyards and wine production, making it one of India’s premier wine regions. The region is home to several famous vineyards, including Sula Vineyards, which is the largest and most popular among them. Visitors can enjoy guided wine-tasting sessions, take a tour of the vineyards, and explore the beautiful surroundings of the Nashik Valley. The scenic beauty, combined with the rich aroma of the vineyards and the opportunity to sample local wines, makes Nashik a great destination for wine enthusiasts and those seeking a peaceful getaway."
        },
        {
          title: "Anjneri Hill",
          description: "Anjneri Hill, located on the outskirts of Nashik, is a place of great religious significance. According to legend, it is believed to be the birthplace of Lord Hanuman. The hill is a popular spot for trekking, offering panoramic views of the surrounding valleys and landscapes. The trek to the top is both a spiritual and adventurous experience, making it ideal for those looking to combine nature with a touch of mythology. Anjneri Hill is also a serene place to relax, meditate, and connect with nature while exploring its rich historical and cultural significance."
        },
        {
          title: "Ganga Ghat",
          description: "Ganga Ghat is a sacred spot located along the Godavari River in Nashik, where devotees gather to perform religious rituals. The peaceful ambiance and scenic beauty of the river make it an ideal location for quiet reflection and spiritual activities. The ghat offers stunning views of the river and the surrounding landscape, creating a serene environment for visitors. The site is especially popular during religious festivals when thousands of devotees flock to the ghat to participate in various rituals. For anyone seeking peace and tranquility, Ganga Ghat provides a perfect retreat."
        },
        {
          title: "Nashik Clock Tower",
          description: "The Nashik Clock Tower is a prominent landmark in the heart of the city, offering a glimpse into the region's colonial history. Built during the British era, this clock tower stands tall amidst bustling markets, making it a great spot for leisurely walks and sightseeing. The clock tower is surrounded by vibrant bazaars, where visitors can shop for local handicrafts, textiles, and food. As an important historical monument, the Nashik Clock Tower offers visitors a chance to explore the city’s rich heritage while enjoying the lively atmosphere of the surrounding markets."
        },
        {
          title: "Sula Vineyards",
          description: "Sula Vineyards, one of the most renowned vineyards in India, is located in the picturesque Nashik Valley. The vineyard offers visitors a chance to indulge in wine tasting, explore the picturesque vineyards, and learn about the winemaking process. The property also boasts a beautiful restaurant with stunning views, where guests can enjoy a meal while sipping on some of the best wines in India. Sula Vineyards is the perfect destination for wine lovers, nature enthusiasts, and anyone looking to experience the scenic beauty of Nashik's vineyards."
        },
        {
          title: "Harishchandra Fort",
          description: "Harishchandra Fort, perched atop a hill in the Nashik region, offers visitors stunning panoramic views of the surrounding valleys and hills. The fort is historically significant, with structures dating back to the 12th century. It is a popular destination for trekking enthusiasts who enjoy both the challenge of climbing the hill and the scenic views that reward them at the top. The fort is an ideal spot for history buffs and adventure seekers, offering both a rich historical experience and an opportunity to immerse oneself in nature."
        }
      ],


   services: [
    {
      "name": "Pune to Nashik Cab Service",
      description: "AB Ghule Cabs offers reliable and affordable taxi services from Pune to Nashik. Whether you’re visiting Sula Wine Yards, Dudhsagar Waterfalls, or exploring the scenic beauty of Nashik, we provide excellent car rental services for your journey. Book with us for a hassle-free travel experience."
    },
    {
      "name": "Pune to Nashik Sula Wine Yards",
      description: "Looking to visit the famous Sula Wine Yards in Nashik? Book your taxi with AB Ghule Cabs for a comfortable and convenient ride. Our experienced drivers ensure you enjoy the scenic journey to the wine yards, making your trip memorable."
    },
    {
      "name": "Pune to Nashik Car Rental",
      description: "We offer affordable and reliable car rental services from Pune to Nashik. Choose from our wide range of vehicles to suit your needs and enjoy a smooth and comfortable journey."
    },
    {
      "name": "Pune Nashik Taxi Service",
      description: "AB Ghule Cabs provides premium taxi services from Pune to Nashik. Whether you're planning a weekend getaway or a business trip, our services ensure you travel in comfort and style."
    },
    {
      "name": "Pune to Nashik Airport Cabs",
      description: "Need a ride to or from Nashik Airport? AB Ghule Cabs offers fast and reliable airport transfer services. Our professional drivers ensure timely pick-up and drop-off, providing you with a stress-free experience."
    },
    {
      "name": "Pune to Nashik Outstation Cabs",
      description: "We provide outstation cab services from Pune to Nashik, ensuring a safe, comfortable, and affordable ride. Whether for a day trip or an extended stay, our outstation cabs are the perfect choice for your journey."
    },
    {
      "name": "Pune to Nashik Cab Booking Online",
      description: "Book your Pune to Nashik cab online with AB Ghule Cabs. Our simple online booking process ensures you can reserve your ride quickly and easily, with options for one-way or round-trip services."
    },
    {
      "name": "Nashik Dudhsagar Waterfalls Taxi",
      description: "Plan a trip to the beautiful Dudhsagar Waterfalls near Nashik? Book a reliable taxi with AB Ghule Cabs for a smooth ride. Our well-maintained vehicles and professional drivers will ensure a memorable trip."
    },
    {
      "name": "Pune to Nashik Private Cabs",
      description: "For a more personalized travel experience, book a private cab with AB Ghule Cabs. Our private cabs offer privacy and comfort for your journey from Pune to Nashik."
    },
    {
      "name": "Pune Nashik One-Way Taxi",
      description: "AB Ghule Cabs offers convenient one-way taxi services from Pune to Nashik. Enjoy a hassle-free journey with our affordable and reliable one-way taxi service."
    },
    {
      "name": "Pune to Nashik Round Trip Cabs",
      description: "Looking for a round-trip cab service? Book your Pune to Nashik round-trip cab with AB Ghule Cabs for a convenient and flexible service."
    },
    {
      "name": "Pune to Nashik Cabs",
      description: "Book your Pune to Nashik cab with AB Ghule Cabs for a quick and comfortable journey. Our professional drivers and well-maintained vehicles ensure a smooth ride every time."
    },
    {
      "name": "Cab From Pune to Nashik",
      description: "Planning a trip from Pune to Nashik? AB Ghule Cabs offers convenient and affordable cab services. Book your ride today for a comfortable journey to Nashik."
    },
    {
      "name": "AB Ghule Cabs",
      description: "AB Ghule Cabs provides reliable taxi services in Pune and surrounding areas. We offer a range of vehicles and services, including outstation, airport transfers, and local rides, ensuring comfort, convenience, and affordability."
    },
    {
      "name": "Nashik to Pune Private Car",
      description: "Travel from Nashik to Pune in a private car with AB Ghule Cabs. Enjoy the privacy and comfort of your own space during the journey."
    },
    {
      "name": "Nashik to Pune Cab Booking",
      description: "Book a cab from Nashik to Pune with AB Ghule Cabs for a smooth and efficient ride. Our online booking system makes it easy to reserve a taxi, ensuring a stress-free travel experience."
    },
    {
      "name": "Nashik to Pune Cab Service",
      description: "AB Ghule Cabs offers reliable and affordable cab services from Nashik to Pune. Our experienced drivers ensure your journey is safe, comfortable, and pleasant."
    },
    {
      "name": "Nashik to Pune Cabs",
      description: "Book your taxi from Nashik to Pune with AB Ghule Cabs. We provide efficient and comfortable transportation at competitive prices for a seamless journey."
    },
    {
      "name": "Nashik to Pune Taxi",
      description: "For a comfortable and affordable taxi ride from Nashik to Pune, choose AB Ghule Cabs. Our fleet of well-maintained vehicles ensures a pleasant journey every time."
    },
    {
      "name": "Pune Nashik Taxi",
      description: "AB Ghule Cabs offers reliable and affordable taxi services for your trip from Pune to Nashik. Book your taxi now and enjoy a stress-free, comfortable ride."
    },
    {
      "name": "Pune Nashik Cab",
      description: "Travel from Pune to Nashik in comfort with AB Ghule Cabs. We offer affordable, reliable, and safe taxi services for all your travel needs."
    },
    {
      "name": "Pune to Nashik Taxi",
      description: "Book a taxi from Pune to Nashik with AB Ghule Cabs for a comfortable and affordable ride. Our professional drivers ensure a safe and timely journey."
    },
    {
      "name": "Taxi from Pune to Nashik",
      description: "Need a taxi from Pune to Nashik? AB Ghule Cabs offers reliable, on-time taxi services for all your travel needs. Book now and enjoy a smooth, stress-free ride."
    },
    {
      "name": "Pune Airports to Nashik Cabs",
      description: "Traveling from Pune Airport to Nashik? AB Ghule Cabs provides airport transfers with professional drivers to ensure a comfortable and timely ride to Nashik."
    },
    {
      "name": "Pune to Nashik Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Nashik Cabs. We ensure a smooth and enjoyable ride for all our customers. Pune is approximately 210 km from Nashik."
    }
  ],

  tableData: [
    ["Pune to Nashik Cab Service", "-Affordable Cabs Pune to Nashik"],
    ["Pune to Nashik Sula wine yards", "-Pune to Nashik Car Rental"],
    ["Pune Nashik Taxi Service", "-Pune to Nashik Airport Cabs"],
    ["Pune to Nashik Outstation Cabs", "-Pune to Nashik Cab Booking Online"],
    ["Nashik Dudhsagar Water Falls Taxi", "-Pune to Nashik Private Cabs"],
    ["Pune Nashik One-Way Taxi", "-Pune to Nashik Round Trip Cabs"],
    ["Pune to Nashik Cabs", "-Cab From Pune to Nashik"],
    ["AB Ghule Cabs, Nashik to Pune Private Car", ""],
    ["Nashik to Pune Cab Booking", "-Nashik to Pune Cab Service"],
    ["Nashik to Pune Cabs", "-Nashik to Pune Taxi"],
    ["Pune Nashik Taxi", "-Pune Nashik Cab"],
    ["Pune Nashik Taxi", "-Pune to Nashik Taxi"],
    ["Taxi from pune to Nashik", "-Pune airports to Nashik cabs"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Timely Service",
      WhyChoosedescription: "AB Ghule Cabs ensures punctual and dependable cab services for your Pune to Nashik journey. Our drivers are well-trained to ensure you reach your destination on time, whether it’s for business, a leisure trip, or a family vacation."
    },
    {
      WhyChooseheading: "Comfortable and Spacious Vehicles",
      WhyChoosedescription: "Travel comfortably with our range of well-maintained vehicles, including sedans, SUVs, and luxury cars. Our cars are spacious, providing enough legroom and comfort for a relaxing journey between Pune and Nashik."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our team of drivers is highly experienced and familiar with the best routes from Pune to Nashik. They are trained, background-checked, and committed to delivering a safe, smooth, and comfortable ride."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive rates for Pune to Nashik cabs, with no hidden charges. Our transparent pricing ensures that you know the exact fare upfront, providing value for money with no surprises."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether you're traveling early in the morning or late at night, AB Ghule Cabs is available around the clock. You can rely on us for a hassle-free booking experience at any time."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "We take great pride in maintaining our vehicles in pristine condition. All our cars undergo regular servicing and cleaning to ensure a smooth and enjoyable ride, whether you are traveling a short or long distance."
    },
    {
      WhyChooseheading: "Safe and Comfortable Rides",
      WhyChoosedescription: "Safety is our top priority. Our vehicles are equipped with GPS for navigation, and our experienced drivers ensure that your trip from Pune to Nashik is safe, comfortable, and stress-free."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking a cab is quick and easy with AB Ghule Cabs. You can book online via our website, app, or simply call our customer service to arrange your ride at your convenience."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Pune to Nashik cab with AB Ghule Cabs?',
      answer: 'You can book a cab easily through our website, mobile app, or by calling our customer service. Our booking process is straightforward and quick.',
    },
    {
      id: 'FAQ2',
      question: 'Are the drivers experienced for Pune to Nashik trips?',
      answer: 'Yes, our drivers are highly experienced with the Pune to Nashik route. They are well-versed in traffic conditions and ensure that you have a safe, smooth journey.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking from Pune to Nashik?',
      answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars, depending on your preferences and travel requirements.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride from Pune to Nashik?',
      answer: 'We offer flexible payment options, including cash, credit/debit cards, or online payment via our mobile app. Choose the option that suits you best.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round trip from Pune to Nashik?',
      answer: 'Yes, you can easily book a round trip from Pune to Nashik. During your booking, just mention the details of your return journey, and we will arrange everything for you.',
    },
    {
      id: 'FAQ6',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, depending on the nature of your trip. However, we offer transparent pricing, and any extra charges will be communicated to you upfront.',
    },
    {
      id: 'FAQ7',
      question: 'Do you provide services for Nashik sightseeing or local travel?',
      answer: 'Yes, AB Ghule Cabs offers sightseeing and local travel services in Nashik. You can book a cab for exploring local attractions or for a day of sightseeing around the city.',
    },
    {
      id: 'FAQ8',
      question: 'Can I travel with extra luggage on a Pune to Nashik trip?',
      answer: 'We allow standard luggage per passenger, but extra luggage can be accommodated upon request. Please inform us during booking so we can make necessary arrangements.',
    },
    {
      id: 'FAQ9',
      question: 'Is AB Ghule Cabs available for corporate travel between Pune and Nashik?',
      answer: 'Yes, we offer reliable and comfortable transportation solutions for corporate travel. We provide customized packages for businesses that require regular travel or group bookings.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs the best choice for Pune to Nashik travel?',
      answer: 'AB Ghule Cabs stands out due to our experienced drivers, affordable rates, well-maintained fleet, 24/7 availability, and excellent customer support. We ensure that your trip from Pune to Nashik is seamless, comfortable, and safe.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Rajesh Patil',
      feedback: 'I traveled from Pune to Nashik with AB Ghule Cabs and had a great experience. The cab was clean, spacious, and the driver was professional and courteous. The entire journey was smooth and comfortable. I highly recommend their services for anyone looking to travel between Pune and Nashik.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Kavita Shah',
      feedback: 'I needed a cab for a business trip to Nashik, and AB Ghule Cabs was the perfect choice. The driver was punctual, and the vehicle was in excellent condition. It was a hassle-free ride, and I reached Nashik on time for my meetings. Great service!',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Nashik Cabs | Reliable & Affordable</title>
  <meta name="description" content="Book affordable and reliable Pune to Nashik cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and private cab services available. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Nashik Cab Service, Affordable Cabs Pune to Nashik, Pune to Nashik Sula wine yards, Pune to Nashik Car Rental, Pune Nashik Taxi Service, Pune to Nashik Airport Cabs, Pune to Nashik Outstation Cabs, Pune to Nashik Cab Booking Online, Nashik Dudhsagar Water Falls Taxi, Pune to Nashik Private Cabs, Pune Nashik One-Way Taxi, Pune to Nashik Round Trip Cabs, Pune to Nashik Cabs, Cab From Pune to Nashik, AB Ghule Cabs, Nashik to Pune Private Car, Nashik to Pune Cab Booking, Nashik to Pune cab Service, Nashik to Pune Cabs, Nashik to Pune Taxi, Pune Nashik Taxi, Pune Nashik Cab, Pune Nashik Taxi, Pune to Nashik Taxi, Taxi from Pune to Nashik, Pune airports to Nashik cabs" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Nashik Cabs | Reliable & Affordable" />
  <meta property="og:description" content="Book affordable and reliable Pune to Nashik cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and private cab services available. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-Nashik-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-Nashik-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Nashik Cabs",
        description: "Book affordable and reliable Pune to Nashik cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and private cab services available. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-Nashik-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-Nashik-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-Nashik-cabs.jpg",
        "priceRange": "₹2000 - ₹6000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-Nashik-cabs",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "1200"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ankit Desai"
            },
            "datePublished": "2024-12-23",
            "reviewBody": "Professional drivers and excellent service. The ride from Pune to Nashik was smooth and comfortable."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Pooja Shah"
            },
            "datePublished": "2024-12-20",
            "reviewBody": "Booked a cab to visit Sula Vineyards. Great experience with AB Ghule Cabs!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Nashik",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "19.9975",
            "longitude": "73.7898"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-Nashik-cabs"
        },
        "keywords": "Pune to Nashik Cab Service, Affordable Cabs Pune to Nashik, Pune to Nashik Sula wine yards, Pune to Nashik Car Rental, Pune Nashik Taxi Service, Pune to Nashik Airport Cabs, Pune to Nashik Outstation Cabs, Pune to Nashik Cab Booking Online, Nashik Dudhsagar Water Falls Taxi, Pune to Nashik Private Cabs, Pune Nashik One-Way Taxi, Pune to Nashik Round Trip Cabs, Pune to Nashik Cabs, Cab From Pune to Nashik, AB Ghule Cabs, Nashik to Pune Private Car, Nashik to Pune Cab Booking, Nashik to Pune cab Service, Nashik to Pune Cabs, Nashik to Pune Taxi, Pune Nashik Taxi, Pune Nashik Cab, Pune Nashik Taxi, Pune to Nashik Taxi, Taxi from Pune to Nashik, Pune airports to Nashik cabs"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/16.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetonashikcabs;